import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Button": Button, "@mui/material/Dialog": Dialog, "@mui/material/ListItemText": ListItemText, "@mui/material/ListItemButton": ListItemButton, "@mui/material/List": List, "@mui/material/Divider": Divider, "@mui/material/AppBar": AppBar, "@mui/material/Toolbar": Toolbar, "@mui/material/IconButton": IconButton, "@mui/material/Typography": Typography, "@mui/icons-material/Close": CloseIcon, "@mui/material/Slide": Slide } } });
export default ClientProvider;
